export default function AdminDashboardHome() {
  return (
    <div>
      <h2>Business Users Only</h2>
      
    </div>
  );
}